import React from 'react';
import { ThemedText } from '../../../components';
import { WaveformAudioPlayer } from '../../../components/FormBuilder/WaveformAudioPlayer';

export default function AudioPlayerValue({ value, field, attachments, emptyValue = '—', theme }) {
  const fieldKey = field?.id || field?.key;
  const audioAttachment = attachments?.find(
    a => a.fieldName === fieldKey && a.type === 'Voice'
  );
  const audioUrl = audioAttachment?.url || (typeof value === 'string' ? value : null);

  if (!audioUrl) {
    return <ThemedText style={{ color: theme?.colors?.muted }}>{emptyValue}</ThemedText>;
  }

  return (
    <div>
      <WaveformAudioPlayer src={audioUrl} theme={theme} attachment={audioAttachment} />
      {audioAttachment?.transcript && (
        <ThemedText type="small" style={{ color: theme?.colors?.muted, marginTop: theme?.spacing?.xs || 4, fontStyle: 'italic' }}>
          {audioAttachment.transcript}
        </ThemedText>
      )}
    </div>
  );
}
